import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import moment from 'moment-jalaali';
import Form from '../../Components/Boilerplates/Forms/Forms';
import Listview from '../../Components/Boilerplates/Listview/Listview';
import useHttp from '../../hooks/http';

const manageTypes = {
  Add: {
    type: 'form',
    inputs: [
      {
        id: 'synoptic_id',
        elementConfig: {
          type: 'text',
          placeholder: 'کد سینوپتیک',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
      },
      {
        id: 'rainfall',
        elementConfig: {
          type: 'text',
          placeholder: 'بارش',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'min_temp',
        elementConfig: {
          type: 'text',
          placeholder: 'دمای حداقل',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'mean_temp',
        elementConfig: {
          type: 'text',
          placeholder: 'دمای متوسط',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'max_temp',
        elementConfig: {
          type: 'text',
          placeholder: 'دمای حداکثر',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'sknt',
        elementConfig: {
          type: 'text',
          placeholder: 'سرعت باد',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'drct',
        elementConfig: {
          type: 'text',
          placeholder: 'جهت باد',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'relh',
        elementConfig: {
          type: 'text',
          placeholder: 'رطوبت نسبی',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
    ],
    url: 'add/synoptic_detail/',
    title: 'افزودن اطلاعات ایستگاه سینوپتیک',
  },
  Upload: {
    type: 'form',
    inputs: [
      {
        id: 'synoptic_id',
        elementConfig: {
          type: 'text',
          placeholder: 'کد سینوپتیک',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
        queryParams: true,
      },
      {
        id: 'file',
        elementConfig: {
          type: 'file',
          accept: 'csv',
          placeholder: 'Sfile',
        },
        value: '',
        validation: {
          required: true,
        },
        valid: false,
        touched: true,
        single: true,
      },
    ],
    url: 'upload/synoptic_detail',
    title: 'آپلود اطلاعات ایستگاه سینوپتیک',
  },
  Get: {
    type: 'form',
    inputs: [
      {
        id: 'synoptic_id',
        elementConfig: {
          type: 'text',
          placeholder: 'کد سینوپتیک',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
        queryParams: true,
      },
      {
        id: 'start_date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ شروع',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
        queryParams: true,
      },
      {
        id: 'end_date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ پایان',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
        queryParams: true,
      },
    ],
    method: 'GET',
    notjson: true,
    handleResponse: (response, setMessage) => {
      if (response.ok) {
        return response
          .blob()
          .then((data) => {
            const the = response.headers.get('Content-disposition');
            const thea = the.slice(the.indexOf('"') + 1, the.length - 1);

            return {
              blob: data,
              fileName: thea,
            };
          })
          .then(({ blob, fileName }) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove(); //afterwards we remove the element again)
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        setMessage({ message: response.statusText, type: 'error' });
      }
    },
    btnText: 'دریافت',
    url: 'download/admin/synoptic_detail',
    title: 'دریافت اطلاعات ایستگاه سینوپتیک',
  },
  List: {
    type: 'list',
    data: {
      id: 'synoptic_id',
      urlF: 'list_view/synoptic_station',
      urlS: 'list_view/synoptic_detail',
      list2: [
        { en: 'wind_direction_degree', fa: 'جهت باد' },
        { en: 'relative_humidity', fa: 'رطوبت نسبی' },
        { en: 'medium_temp', fa: 'دمای هوا' },
      ],
    },
  },
};

const Synoptic = () => {
  const { type } = useParams();
  const thisPageData = useMemo(() => ({ ...manageTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const [codes, setCodes] = useState();

  useEffect(() => {
    sendRequest('get/synoptic_station/', 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      const the = [];

      data.forEach((element) => {
        the.push({ value: element.name, gainValue: element.id });
      });

      setCodes({
        elementConfig: {
          type: 'select',
          placeholder: 'کد ایستگاه',
          options: the,
        },
        indexValue: -1,
      });
      clear();
    }
  }, [error, isLoading, data, clear, setCodes]);

  const theReturn = useMemo(() => {
    switch (thisPageData.type) {
      case 'list':
        return <Listview {...thisPageData.data} />;
      case 'form':
      default:
        const theInputs = [...thisPageData.inputs];
        if (codes) {
          theInputs[0] = { ...theInputs[0], ...codes };
        }

        return (
          <Form
            {...thisPageData}
            inputs={theInputs}
            pageTitle={thisPageData.title ? thisPageData.title : ''}
            header={{ Authorization: `Bearer ${token}` }}
            btnStyle={{
              borderRadius: '25px',
              width: '100px',
              marginLeft: '2rem',
              fontWeight: 'bold',
            }}
          />
        );
    }
  }, [thisPageData, token, codes]);

  return theReturn;
};

export default Synoptic;
